import { isString } from '@yescapa-dev/ysc-api-js/modern'
import type { LocationQuery } from '#vue-router'

export const queryValueToString = (x: LocationQuery[string]): string | null => x ? (isString(x) ? x : x[0]) : null
